import React, { useState } from 'react';
import { Button, CircularProgress, useTheme } from '@mui/material';
import { Favorite, FavoriteBorder } from '@mui/icons-material';
import axios from 'axios';
import Swal from 'sweetalert2';

const WishlistButton = ({ courseId, isWishlisted, variant = "contained" }) => {
  const [wishlisted, setWishlisted] = useState(isWishlisted);
  const [loading, setLoading] = useState(false);
  const theme = useTheme();

  const handleToggleWishlist = async () => {
    const token = localStorage.getItem('jwttoken');

    if (!courseId || !token) {
      console.error('Missing courseId or token.');
      return;
    }

    const url = `https://tdtlworld.com/dss-kaas-backend/lms/user/wishlist/${courseId}/`;
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    };

    try {
      setLoading(true);

      if (wishlisted) {
        await axios.delete(url, { headers });
        Swal.fire({
          icon: 'success',
          title: 'Removed!',
          text: 'Course removed from your wishlist.',
          confirmButtonColor: '#D4AF37'
        });
        setWishlisted(false);
      } else {
        await axios.post(url, {}, { headers });
        Swal.fire({
          icon: 'success',
          title: 'Added!',
          text: 'Course added to your wishlist.',
          confirmButtonColor: '#D4AF37'
        });
        setWishlisted(true);
      }
    } catch (error) {
      console.error('Error during wishlist toggle:', error.response || error);
      if (error.response?.data?.error === 'Course is already in the wishlist.') {
        Swal.fire({
          icon: 'info',
          title: 'Already in Wishlist',
          text: 'This course is already in your wishlist.',
          confirmButtonColor: '#D4AF37'
        });
        setWishlisted(true);
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: 'Could not update wishlist. Please try again.',
          confirmButtonColor: '#D4AF37'
        });
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant={wishlisted ? "outlined" : variant}
      color={wishlisted ? "error" : "primary"}
      onClick={(e) => {
        e.stopPropagation();
        handleToggleWishlist();
      }}
      disabled={loading}
      startIcon={loading ? <CircularProgress size={16} color="inherit" /> : (wishlisted ? <Favorite /> : <FavoriteBorder />)}
      sx={{ 
        borderRadius: '50px', 
        fontWeight: 800,
        textTransform: 'none',
        minWidth: '160px',
        px: 3
      }}
    >
      {loading ? 'Processing...' : (wishlisted ? 'Already Wishlisted' : 'Add to Wishlist')}
    </Button>
  );
};

export default WishlistButton;
